module.exports = __webpack_public_path__ + "static/img/icon_footer_link.e80ec06.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_footer_link.svg
// module id = BW6b
// module chunks = 10